export const API_STATUS = "API_STATUS";
export const DELETE_PDF = "DELETE_PDF";
export const PRE_PRO_PROJECTS = "PRE_PRO_PROJECTS";
export const CLEAR_API_STATUS = "CLEAR_API_STATUS";
export const UPLOADED_TEMPLATE_AND_PARAMETERS =
  "UPLOADED_TEMPLATE_AND_PARAMETERS";
export const GET_TAGS = "GET_TAGS";
export const UPLOADED_BATCH_PDFS = "UPLOADED_BATCH_PDFS";
export const GET_USER_LIST = "GET_USER_LIST";
export const IS_SIGNATURE_UPLOADED_STATUS = "IS_SIGNATURE_UPLOADED_STATUS";
export const ASSIGN_USER_API_STATUS = "ASSIGN_USER_API_STATUS";
export const VALIDATE_USER_STATUS = "VALIDATE_USER_STATUS";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const GET_UPLOADED_PDF_TAGS = "GET_UPLOADED_PDF_TAGS";
export const GET_COOR_DATA = "GET_COOR_DATA";
export const GET_PROJECT_TYPE_LIST = "GET_PROJECT_TYPE_LIST";
export const GET_PROJECT_TYPE = "GET_PROJECT_TYPE";
export const GET_OUTPUT_FORMAT_LIST = "GET_OUTPUT_FORMAT_LIST";
export const GET_SHEETS_LIST = "GET_SHEETS_LIST";
export const AUTO_REFRESH = "AUTO_REFRESH";
export const SET_SELECTED_FILES_DATA_FOR_PRO_UPDATE =
  "SET_SELECTED_FILES_DATA_FOR_PRO_UPDATE";
export const OCR_REINITIATE_STATUS = "OCR_REINITIATE_STATUS";
export const RESET_PRO_DATA_FROM_PRE = "RESET_PRO_DATA_FROM_PRE";
export const GET_TAGS_USERS_PDFS = "GET_TAGS_USERS_PDFS";
// export const SAVED_BATCHES_DATA = "SAVED_BATCHES_DATA";
export const GET_QC_TEMPLATE_FORMAT = "GET_QC_TEMPLATE_FORMAT";
export const QC_PARAMETERS_DATA = "QC_PARAMETERS_DATA";
export const QC_SAVE_MAPPING_STATUS = "QC_SAVE_MAPPING_STATUS";
export const LIST_UPLOADED_FILES_RECORD = "LIST_UPLOADED_FILES_RECORD";
export const UPLOADING_IP_OP_FILE_PREVIEW = "UPLOADING_IP_OP_FILE_PREVIEW";
export const CLONE_API_STATUS = "CLONE_API_STATUS"
export const SET_BBOX_FROM_DRAW_FROM_PRE = "SET_BBOX_FROM_DRAW_FROM_PRE";
export const HIGHLIGHT_BBOX_IN_PRE = "HIGHLIGHT_BBOX_IN_PRE";
export const GET_INVESTIGATOR_USER_LIST = "GET_INVESTIGATOR_USER_LIST";